import jwt_decode from 'jwt-decode';
import '../../scripts/custom-event-polyfill';
import chevronIcon from '../../assets/images/icons/chevron-right.svg';
import { defaultConfig, eventContextChanged, eventContextSwitcherReady } from './cam-context-switcher-constants';
import camContextSwitcherDatastore from './cam-context-switcher-datastore';
import './cam-context-switcher-panel';

const tagName = 'cam-context-switcher';
const template = require('../templates/cam-context-switcher.ejs');

const mockData = require('./mockData.json');

export default class CamContextSwitcher extends HTMLElement {

  constructor() {
    super();
    this.datastore = camContextSwitcherDatastore;
  }

  connectedCallback() {
    this.id = tagName;
    this.classList.add(tagName);

    this.timeout = this.getAttribute('timeout') || 10000;

    document.addEventListener(eventContextChanged, this.handleContextChanged.bind(this));

    this.dispatchEvent(new CustomEvent(eventContextSwitcherReady, { bubbles: true }));

  }

  disconnectedCallback() {
    document.removeEventListener(eventContextChanged, this.handleContextChanged.bind(this));
  }

  personalWorkspace(workspaceList, userName) {
    return workspaceList.find((ws) => ws.type === 'personal_workspace' && ws.id === userName);
  }

  renderCamContextSwitcher() {
    let workspace = this.datastore.selectedWorkspace;

    this.innerHTML = template({
      workspace: workspace,
      display: this.datastore.displayWorkspace(workspace),
      icons: {
        chevron: chevronIcon
      }
    });
  }

  populate(token, config={}) {
    config = Object.assign(defaultConfig, config);
    // Mock data for live example
    if (token === 'mock_token') {
      console.warn('Context switcher was populated with Mock data');
      this.datastore.initializeData(mockData, 'mockuser1', 'mockuser1', config);
      return;
    }

    let jwt = jwt_decode(token);
    let url = config.apiUrl.replace('/+$', '') + '/services/scopes';

    let httpConfig = {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    };
    fetch(url, httpConfig).then((res) => res.json()).then((res) => {
      this.datastore.initializeData(res, jwt.sub, this.selectedWorkspaceId, config);
      this.renderCamContextSwitcher();
    }).catch((err) => {
      console.error(err);
    });

  }

  handleContextChanged() {
    this.renderCamContextSwitcher();
  }

}

customElements.define(tagName, CamContextSwitcher);



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher.js